import React from 'react';
import { colors, radius } from '../theme';
import { PRIVACY_LABEL } from './TiktokPostSettings';

// Layar preview WAJIB TikTok Content Posting API — ditampilkan di modal konfirmasi
// SEBELUM request publish dikirim. Guideline yang dipenuhi di sini:
//  - "API Clients should display a preview of the to-be-posted content"
//  - "the upload page must display the creator's nickname, so users are aware of
//     which TikTok account the content will be uploaded to"
//  - interaksi yang di-disable creator_info harus tetap kelihatan terkunci di sini
//  - user diberi tahu konten butuh beberapa menit untuk diproses TikTok
// Sumber data caps = hasil creator_info live yang diangkat dari TiktokPostSettings,
// JANGAN diganti baca kolom caps_* di DB (itu snapshot, bukan data live).

const COMMERCIAL_LABEL = (s) => {
  if (!s.is_commercial) return null;
  if (s.is_branded_content) return 'Paid partnership';
  if (s.is_your_brand) return 'Promotional content';
  return null;
};

const TOGGLES = [
  { k: 'allow_comment', cap: 'comment_disabled', label: 'Komentar' },
  { k: 'allow_duet', cap: 'duet_disabled', label: 'Duet' },
  { k: 'allow_stitch', cap: 'stitch_disabled', label: 'Stitch' },
];

export default function TiktokPreviewConfirm({ accounts, settings, caps, caption, videoUrl, thumbnailUrl }) {
  if (!accounts || accounts.length === 0) return null;

  // Catatan penutup harus jujur: kalau ada akun yang dijadwalkan, jangan bilang
  // kontennya langsung dikirim setelah konfirmasi.
  const adaJadwal = accounts.some(a => (settings && settings[a.id] || {}).scheduled_at);

  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: colors.textPrimary, marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
        <i className="ti ti-brand-tiktok" style={{ fontSize: 15 }}></i>Preview Posting TikTok
      </div>

      {accounts.map(a => {
        const c = (caps && caps[a.id]) || {};
        const s = (settings && settings[a.id]) || {};
        const commercial = COMMERCIAL_LABEL(s);

        return (
          <div key={a.id} style={{ border: `1px solid ${colors.border}`, borderRadius: radius.md, padding: 12, marginBottom: 10, background: colors.bgCardMuted }}>

            {/* Akun tujuan — nickname WAJIB tampil sebelum publish */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 10 }}>
              {c.creator_avatar_url
                ? <img src={c.creator_avatar_url} alt="" style={{ width: 30, height: 30, borderRadius: '50%', flexShrink: 0 }} />
                : <div style={{ width: 30, height: 30, borderRadius: '50%', background: colors.border, flexShrink: 0 }} />}
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 12.5, fontWeight: 700, color: colors.textPrimary, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {c.creator_nickname || a.display_name || '—'}
                </div>
                <div style={{ fontSize: 11, color: colors.textSecondary }}>@{c.creator_username || a.username || '—'}</div>
              </div>
            </div>

            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              {/* Thumbnail konten yang akan diupload */}
              {(videoUrl || thumbnailUrl) && (
                <div style={{ width: 84, height: 149, borderRadius: 8, overflow: 'hidden', background: '#000', flexShrink: 0, position: 'relative', border: `1px solid ${colors.border}` }}>
                  {videoUrl
                    ? <video src={videoUrl} muted playsInline style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', height: '100%', width: 'auto', maxWidth: 'none' }} />
                    : <img src={thumbnailUrl} alt="" style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', height: '100%', width: 'auto', maxWidth: 'none' }} />}
                </div>
              )}

              <div style={{ flex: 1, minWidth: 180 }}>
                <div style={{ marginBottom: 8 }}>
                  <div style={{ fontSize: 10.5, color: colors.textSecondary, marginBottom: 2 }}>Caption</div>
                  <div style={{ fontSize: 12, color: colors.textPrimary, lineHeight: 1.5, wordBreak: 'break-word' }}>
                    {caption || <span style={{ color: colors.textMuted, fontStyle: 'italic' }}>(otomatis dari judul video sumber)</span>}
                  </div>
                </div>

                {s.scheduled_at && (
                  <div style={{ marginBottom: 8 }}>
                    <div style={{ fontSize: 10.5, color: colors.textSecondary, marginBottom: 2 }}>Jadwal Posting</div>
                    <div style={{ fontSize: 12, color: colors.textPrimary, fontWeight: 600 }}>
                      {new Date(s.scheduled_at).toLocaleString('id-ID', { dateStyle: 'medium', timeStyle: 'short' })} WIB
                    </div>
                  </div>
                )}

                <div style={{ marginBottom: 8 }}>
                  <div style={{ fontSize: 10.5, color: colors.textSecondary, marginBottom: 2 }}>Status Privasi</div>
                  <div style={{ fontSize: 12, color: colors.textPrimary, fontWeight: 600 }}>
                    {PRIVACY_LABEL[s.privacy_level] || s.privacy_level || '—'}
                  </div>
                </div>

                <div>
                  <div style={{ fontSize: 10.5, color: colors.textSecondary, marginBottom: 4 }}>Izinkan Interaksi</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    {TOGGLES.map(t => {
                      const locked = !!c[t.cap];
                      const on = !locked && !!s[t.k];
                      return (
                        <div key={t.k} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11.5, color: locked ? colors.textMuted : colors.textPrimary }}>
                          <i className={`ti ${locked ? 'ti-lock' : on ? 'ti-circle-check-filled' : 'ti-circle-minus'}`}
                            style={{ fontSize: 14, color: locked ? colors.textMuted : on ? colors.success : colors.textSecondary, flexShrink: 0 }}></i>
                          <span>{t.label}</span>
                          <span style={{ fontSize: 10.5, color: locked ? colors.textMuted : on ? colors.success : colors.textSecondary }}>
                            {locked ? '— dikunci pengaturan akun TikTok' : on ? 'ON' : 'OFF'}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {commercial && (
                  <div style={{ marginTop: 8, fontSize: 11, color: colors.warning, background: colors.warningMuted, padding: '4px 8px', borderRadius: 6, display: 'inline-block' }}>
                    Label konten: <strong>{commercial}</strong>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}

      <div style={{ fontSize: 11, color: colors.textSecondary, lineHeight: 1.6, padding: '8px 10px', background: colors.bgCardMuted, borderRadius: 8 }}>
        <i className="ti ti-clock" style={{ fontSize: 13, marginRight: 5, verticalAlign: '-2px' }}></i>
        {adaJadwal
          ? 'Konten dikirim ke TikTok pada jadwal yang kamu tentukan di atas, lalu butuh beberapa menit untuk diproses sebelum muncul di akun tujuan.'
          : 'Setelah dikonfirmasi, konten dikirim ke TikTok dan butuh beberapa menit untuk diproses sebelum muncul di akun tujuan.'}
      </div>
    </div>
  );
}
